import { render, staticRenderFns } from "./realdata.vue?vue&type=template&id=f9e0ce46&scoped=true"
import script from "./realdata.vue?vue&type=script&lang=js"
export * from "./realdata.vue?vue&type=script&lang=js"
import style0 from "./realdata.vue?vue&type=style&index=0&id=f9e0ce46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e0ce46",
  null
  
)

export default component.exports